module.exports = __webpack_public_path__ + "static/media/M1-19-Öthuren-Djelko-cod128.a9c8b0ea.png";